// extracted by mini-css-extract-plugin
export default {"container":"ShipmentsEventListItemProgressBar_container__HvUON"};